import Vue from 'vue'
import VueParticles from 'vue-particles'
import App from './App.vue'
import router from './router'
import store from './store'
import device from 'vue-device-detector'
import '@babel/polyfill'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import { KinesisContainer, KinesisElement } from 'vue-kinesis'
import moment from 'moment'
import VueMask from 'v-mask'
import { API_DATE_FORMAT, HUMAN_READABLE_DATE_FORMAT, VUETIFY_DATE_FORMAT } from './const'
import { FEATURES, FEATURES_PERFILES, MODULOS_PERFILES, PERFILES } from './perfiles'
import { MODULOS_COLORES } from './modulosColores'
import { mapGetters } from 'vuex'

Vue.config.productionTip = false

Vue.use(VueParticles)
Vue.use(device)
Vue.use(VueApexCharts)
Vue.use(VueMask)

Vue.component('apexchart', VueApexCharts)
Vue.component('kinesis-container', KinesisContainer)
Vue.component('kinesis-element', KinesisElement)

Vue.mixin({
  data() {
    return {
      API_DATE_FORMAT,
      VUETIFY_DATE_FORMAT,
      HUMAN_READABLE_DATE_FORMAT,
      PERFILES,
      MODULOS_PERFILES,
      FEATURES_PERFILES,
      FEATURES,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),

    isAdminUser() {
      return this.perfil === PERFILES['Administrador IPH+']
    },
  },

  methods: {
    setThemeByModule(modulo) {
      const moduloSeleccionado = MODULOS_COLORES[modulo]
      this.$vuetify.theme.themes.light.primary = moduloSeleccionado.primary
      this.$vuetify.theme.themes.light.secondary = moduloSeleccionado.secondary
      this.$vuetify.theme.themes.light.accent = moduloSeleccionado.accent
      this.$vuetify.theme.themes.light.anchor = moduloSeleccionado.anchor
    },
    hasAccessToModule: (perfil, modulo) => {
      if (!PERFILES[perfil]) {
        return false
      }
      return MODULOS_PERFILES[modulo]?.includes(PERFILES[perfil]) || false
    },

    hasAccessToFeature: (perfil, feature) => {
      if (perfil === PERFILES['Administrador IPH+']) return true

      if (!PERFILES[perfil]) {
        return false
      }

      return FEATURES_PERFILES[feature]?.includes(PERFILES[perfil]) || false
    },

    formatDate: function (date) {
      if (date) {
        return moment(date).format(API_DATE_FORMAT)
      } else return null
    },
    getDateText(fecha) {
      return moment(fecha, API_DATE_FORMAT).isValid()
        ? moment(fecha, API_DATE_FORMAT).format('DD') +
            ' de ' +
            moment(fecha, API_DATE_FORMAT).format('MMMM') +
            ' del ' +
            moment(fecha, API_DATE_FORMAT).format('YYYY')
        : ''
    },
    getToday: function () {
      return moment().format(VUETIFY_DATE_FORMAT)
    },
    getFullName(person) {
      if (!person) return ''
      if (person.segundoNombre == '') {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre
      } else {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre + person.segundoNombre
      }
    },
    getAge(birthdayDate) {
      if (!birthdayDate) return ''
      const birthMoment = moment(birthdayDate, API_DATE_FORMAT)
      if (!birthMoment.isValid()) return ''
      const years = moment().diff(birthMoment, 'years')
      return years ? years + ' años' : ''
    },
    logout() {
      localStorage.removeItem('nombre')
      localStorage.removeItem('token')
      localStorage.removeItem('perfil')
      localStorage.removeItem('idPersonal')
      localStorage.removeItem('idSede')
      localStorage.removeItem('idSubsede')
    },
    download: function (url) {
      window.open(url, '_blank')
    },
    getDocumentType: function (name) {
      if (name.substr(name.length - 3).toLowerCase() == 'jpg' || name.substr(name.length - 3).toLowerCase() == 'png') {
        return 'img'
      } else if (name.substr(name.length - 3).toLowerCase() == 'pdf') {
        return 'pdf'
      } else {
        return '0'
      }
    },

    tieneC3Vigente(fecha_vigencia) {
      if (fecha_vigencia !== '') {
        return moment(fecha_vigencia, API_DATE_FORMAT).diff(moment(), 'months', true) > 7 ? true : false
      } else return false
    },
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
